export default __webpack_public_path__ + "static/media/milho.98445416.png";